var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataEntry',{attrs:{"reuseComponent":_vm.reuseComponent,"downloadColumns":_vm.downloadColumns}})
}
var staticRenderFns = []

export { render, staticRenderFns }